export class HttpError<T = unknown> extends Error {
  public readonly name: string = 'HttpError';

  /**
   * @param data レスポンスボディ。409 の current_status のように
   *   status / message だけでは表現できない情報を呼び出し側へ渡すために保持する。
   *   optional なので既存の呼び出し箇所には影響しない。
   */
  constructor(public status: number, public message: string, public data?: T) {
    super(message);
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}
